import {ClickEvent} from "../../infrastructure/models/analytics/click-event";
import {APP} from "../app/consts";

export class SeeAllClickEvent extends ClickEvent {
  source: APP.ANALYTICS.SOURCES;
  screen: String;
  sportTypeId: Number;

  constructor(params) {
    super('click', 'see-all');

    this.source = params.source;
    this.screen = params.screen;
    this.sportTypeId = params.sportTypeId;
  }

  get properties() {
    const properties = super.properties;

    properties.source = this.source;
    properties.screen = this.screen;
    properties.sportTypeId = this.sportTypeId;

    return properties;
  }
}
